<template>
  <v-card v-if="taskNotification.length" class="my-4">
    <v-toolbar color="primary" flat dark>
      <v-toolbar-title>Notifications</v-toolbar-title>
    </v-toolbar>
    <v-list class="pa-4 notif-list" two-line>
      <!-- <v-subheader>Unread</v-subheader> -->
      <template v-for="(item, index) in taskNotification">
        <v-divider :key="`dvt-${index}`" v-if="index > 0" />
        <component
          :key="`not-${index}`"
          :is="componentName[item.data.component_type]"
          :notification="item"
          :isTask="true"
          @readAndGo="goToSource(item)"
          @read="markAsRead(item)"
        />
      </template>
    </v-list>
  </v-card>
</template>

<script>
import Notification from '@/modules/auth/models/Notification'
import AccessChange from '@/components/notification/type/AccessChange'
import { mapMutations } from 'vuex'
import { filter } from 'lodash'

export default {
  name: 'Notifications',
  components: {
    AccessChange
  },
  props: {
    type: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      task_notification_component: ['access_change'],
      componentName: {
        access_change: AccessChange
      }
    }
  },
  async mounted() {
    try {
      await Notification.dispatch('getAll', this.type)
    } catch (error) {
      this.showErrorSnackbar('Error retrieving notifications')
    }
  },
  computed: {
    taskNotification() {
      return filter(
        this.notifications,
        notification =>
          this.task_notification_component.includes(
            notification.data.component_type
          ) && !notification.read_at
      )
    },
    notifications() {
      return Notification.query().get()
    }
  },
  methods: {
    ...mapMutations('snackbar', ['showErrorSnackbar']),
    async goToSource(notification) {
      let sameRoute = false
      // let query = Object.assign({}, this.$route.query)

      if (this.$router.currentRoute.name === 'Classes') sameRoute = true

      // query.currentClassId = notification.data.custom_class_id
      // query.currentParentTab = 'students'
      // query.currentChildTab = '0'
      // query.classInvitationId = notification.data.class_invitation_id
      // query.studentId = notification.data.student_id
      // this.$router.push({
      //   name: 'Classes',
      //   query: query
      // })

      this.$router.push({
        path: `/teacher/dashboard/classes?currentClassId=${notification.data.custom_class_id}&currentParentTab=students&currentChildTab=0&classInvitationId=${notification.data.class_invitation_id}&studentId=${notification.data.student_id}`
      })

      await this.markAsRead(notification)
      if (sameRoute) this.$router.go()
    },
    async markAsRead(notification) {
      const payload = {
        type: this.type,
        id: notification.id
      }
      await Notification.dispatch('readSingle', { payload: payload })
    }
  }
}
</script>
